// removed by extract-text-webpack-plugin
module.exports = {"icon":"src-components-icon----styles-module---icon---2zdnD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/icon/styles.module.css
// module id = 100
// module chunks = 7555878655471 88746230898986